import { useContext } from 'react';
import { Box, Button, ButtonProps, Tooltip } from '@chakra-ui/react';
import { MeContext } from '../../context/MeContext';
import {
  goLiveActionPrefix,
  goLiveReasonMessage,
} from '../../constants/goLiveReasons';

interface LockedActionButtonProps extends ButtonProps {
  reason?: string;
}

const LockedActionButton = ({
  reason,
  children,
  w,
  width,
  minW,
  flexGrow,
  flex,
  alignSelf,
  m,
  mr,
  ml,
  mt,
  mb,
  mx,
  my,
  position,
  top,
  right,
  bottom,
  left,
  ...buttonProps
}: LockedActionButtonProps) => {
  const { state } = useContext(MeContext);
  const locked = state.organisationStatus === 'locked';
  const tooltip =
    goLiveReasonMessage(reason, { locked }) ||
    `${goLiveActionPrefix(locked)} unlock this action`;

  const hasWidth =
    w !== undefined ||
    width !== undefined ||
    minW !== undefined ||
    flexGrow !== undefined ||
    flex !== undefined;

  return (
    <Tooltip
      label={tooltip}
      hasArrow
      placement="top"
      fontSize="12px"
      bg="inkBlue"
      color="white"
      borderRadius="6px"
      textAlign="center"
      p="10px"
    >
      <Box
        as="span"
        display="inline-flex"
        {...{
          w,
          width,
          minW,
          flexGrow,
          flex,
          alignSelf,
          m,
          mr,
          ml,
          mt,
          mb,
          mx,
          my,
          position,
          top,
          right,
          bottom,
          left,
        }}
      >
        <Button
          isDisabled
          w={hasWidth ? 'full' : undefined}
          pointerEvents="none"
          {...buttonProps}
        >
          {children}
        </Button>
      </Box>
    </Tooltip>
  );
};

export default LockedActionButton;
